export default "__VITE_ASSET__Cxrio5ke__"